module.exports = __webpack_public_path__ + "media/images/shared/icon_hotel_black-80ec36337ca11e668bf3820fc66f742c.png";